"use client";

import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";
import { cn } from "@/lib/utils";
import { CheckCircle2Icon } from "lucide-react";

export type SaveStatus = "idle" | "saved";

export type SaveButtonProps = {
  isSaving: boolean;
  hasChanges: boolean;
  savedStatus: SaveStatus;
  onSave: () => void;
  label?: string;
  className?: string;
  size?: "sm" | "default" | "lg";
};

export function SaveButton({
  isSaving,
  hasChanges,
  savedStatus,
  onSave,
  label = "Save changes",
  className,
  size = "sm",
}: SaveButtonProps) {
  const isSaved = savedStatus === "saved" && !hasChanges && !isSaving;

  return (
    <Button
      className={cn(
        isSaved && "border-activated/40 bg-muted text-activated hover:bg-muted/90 disabled:opacity-100",
        className
      )}
      disabled={!hasChanges || isSaving}
      onClick={onSave}
      size={size}
      type="button"
    >
      {isSaving ? (
        <span className="inline-flex items-center gap-2">
          <Spinner className="size-3.5" />
          Saving…
        </span>
      ) : isSaved ? (
        <span className="inline-flex items-center gap-2">
          <CheckCircle2Icon className="size-3.5" />
          Saved
        </span>
      ) : (
        label
      )}
    </Button>
  );
}
